<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="https://pic.imgdb.cn/item/66a9f910d9c307b7e9121100.png" alt="logo图">
    </div>
    <p class="title"></p>
    <p class="address_tel_fax">
      <span>地址：公司地址</span>
      <span>Tel：888-888-888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p>
    <p class="copy">Copyright &copy; 2023 - {{ new Date().getFullYear() }} 泡泡+ xx公司版权所有</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  //background: #02afff;
  background: rgba(227, 81, 35, 0.8);
  overflow: hidden;
  text-align: center;
}

.logo {
  width: 120px;
  height: 50px;
  margin: 50px auto 20px;
}

.logo > img {
  width: 100%;
  height: 100%;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue